import React, { useState } from "react";
import ModalTerms from "components/ModalTerms";

type Props = {};

const TermOfUse: React.FC<Props> = (): JSX.Element => {
  const [show, setShow] = useState(false);

  return (
    <div className="mt-12">
      <ModalTerms show={show} setShow={setShow} />
      <span
        className="flex flex-row cursor-pointer justify-center font-nunito font-light text-xs"
        onClick={() => setShow(true)}
      >
        Term of use. Privacy policy
      </span>
    </div>
  );
};

export default TermOfUse;
